import React from 'react';
import Checkbox from 'pages/Dashboard/components/Input/Checkbox';

type Props = {
  value?: boolean;
  displayName: string;
  onChange: (value: boolean) => void;
};

export default function CheckboxInput({ value, displayName, onChange }: Props) {
  return (
    <Checkbox
      label={displayName}
      id={`filter-${displayName}`}
      checked={value ?? false}
      onChange={onChange}
      classes={{ root: '-mt-3', label: '!font-semibold' }}
    />
  );
}
